import React, { useEffect, useRef } from 'react';
import { confirmReading } from '../../actions/wage/listWage';

import LoadingLayer from '../controls/LoadingLayer';

import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Button from 'react-bootstrap-button-loader';

import Slide from '@material-ui/core/Slide';
import AppBar from '@material-ui/core/AppBar';
import { makeStyles } from '@material-ui/core/styles';
import Toolbar from '@material-ui/core/Toolbar';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import CloseIcon from '@material-ui/icons/Close';
import GetAppIcon from '@material-ui/icons/GetApp';
import PdfViewer from '@shared/pdfViewer/PdfViewer';
import { pdfjs } from 'react-pdf';
import { download } from '../../utils/download';
import * as statusCode from '../../scripts/StatusCode';
import { withNamespaces } from 'react-i18next';
import PropTypes from 'prop-types';
import i18next from 'i18next';
import AlertAlgo from '../controls/AlertSnack'
import styles from '../../styles/popup.module.css';
pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;

const useStyles = makeStyles((theme) => ({
    appBar: {
        position: 'relative',
        backgroundColor: 'var(--color1) !important',
        color: 'var(--color2) !important'
    },
    title: {
        marginLeft: theme.spacing(2),
        flex: 1,
    },
}));

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});


function PdfWage(props) {
    const classes = useStyles();

    const [openPop, setOpenPop] = React.useState(false);
    const [isProcessing, setIsProcessing] = React.useState(false);
    const [isConfirmed, setIsConfirmed] = React.useState(false);
    const [messagePop, setMessagePop] = React.useState('');
    const [titlePop, setTitlePop] = React.useState('');
    const [titlePDF, setTitlePDF] = React.useState('');
    const [data, setData] = React.useState(null);

    const { onClose, open, filename, required, id, confirmed, title } = props;

    const alertRef = useRef(null);

    useEffect(() => {
        setMessagePop(i18next.t('documents:confirm-read'));
        setTitlePop(i18next.t('popup:title.warning'));
    }, []);

    useEffect(() => {
        setData(props.pdfData);
    }, [props.pdfData])

    useEffect(() => {
        setTitlePDF(title);
    }, [title]);

    const handleClosePdf = () => {
        if (required && !confirmed) {
            setOpenPop(true);
        } else {
            onClose(required, confirmed);
        }
    };

    const handleClosePop = () => {
        setOpenPop(false);
        onClose(required, isConfirmed);
    }

    const handleDownload = () => {
        const linkSource = `data:application/octet-stream;base64,${data}`;
        download(linkSource, filename, 'application/octet-stream')
    }

    const handleReadConfirmation = async () => {
        setIsProcessing(true);

        if (id > 0) {

            const response = await confirmReading(id);

            if (response !== undefined && response.status === statusCode.STATUS_OK) {
                setOpenPop(false);
                setTimeout(() => { setIsProcessing(false) }, 700);
                setTimeout(() => { onClose(required, true) }, 800);
            }
            else {
                alertRef.current.showMessageError(i18next.t('error:generic-error'));
                setIsProcessing(false);
            }
        } else {
            alertRef.current.showMessageError(i18next.t('error:generic-error'));
            setIsProcessing(false);
        }
    }

    return (
        <React.Fragment>
            <LoadingLayer isActive={isProcessing}>
                <Dialog fullScreen open={open} onClose={handleClosePdf} TransitionComponent={Transition}>
                    <AppBar className={classes.appBar}>
                        <Toolbar>
                            <IconButton edge="start" color="inherit" onClick={handleClosePdf} aria-label="close">
                                <CloseIcon />
                            </IconButton>
                            <Typography variant="h6" className={classes.title}>
                                {titlePDF}
                            </Typography>
                            <IconButton edge="start" color="inherit" onClick={handleDownload} aria-label="download">
                                <GetAppIcon />
                            </IconButton>
                        </Toolbar>
                    </AppBar>
                    <PdfViewer pdfData={data} />
                </Dialog>

                <Dialog
                    open={openPop}
                >
                    <DialogTitle>
                        {titlePop}
                    </DialogTitle>
                    <DialogContent>
                        <DialogContentText>
                            {messagePop}
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={handleClosePop} color="primary" className={styles.buttonYesNo} variant="success">
                            {i18next.t('popup:button.no')}
                        </Button>
                        <Button autoFocus onClick={handleReadConfirmation} color="primary" className={styles.buttonYesNo} variant="success">
                            {i18next.t('popup:button.yes')}
                        </Button>
                    </DialogActions>
                </Dialog>
            </LoadingLayer>
            <AlertAlgo ref={alertRef} />
        </React.Fragment>
    )
}

export default withNamespaces(['popup', 'documents', 'error'], { wait: true })(PdfWage);

PdfWage.propTypes = {
    required: PropTypes.bool.isRequired
}